var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutdoorExhibition = function SvgOutdoorExhibition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5815_42498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5305 22.8794V3.95117C14.5305 3.39889 14.0828 2.95117 13.5305 2.95117H2.86841C2.31612 2.95117 1.86841 3.39889 1.86841 3.95117V22.8794",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5305 11.4907H21.5432C22.0955 11.4907 22.5432 11.9384 22.5432 12.4907V22.8794",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.72168,
    y1: 22.1794,
    x2: 25.751,
    y2: 22.1794,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.01514,
    y1: 7.32295,
    x2: 7.19846,
    y2: 7.32295,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.01514,
    y1: 9.76973,
    x2: 7.19846,
    y2: 9.76973,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.11865,
    y1: 7.32295,
    x2: 12.302,
    y2: 7.32295,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.11865,
    y1: 9.76973,
    x2: 12.302,
    y2: 9.76973,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5815_42498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
};
export default SvgOutdoorExhibition;